export class PolicyConstant {
    static MODULES = [
        {
            key: 'dashboard',
            name: 'common.dashboard',
            isOwner: false,
            actions: [
                {
                    key: 'view',
                    name: 'View personal dashboard',
                    permissions: [],
                },
                {
                    key: 'view-company',
                    name: 'View company dashboard',
                    permissions: ['analytic::read'],
                },
            ],
        },
        {
            key: 'ceo-analytics',
            name: 'CEO Analytics',
            isOwner: false,
            actions: [
                {
                    key: 'view',
                    name: 'View CEO analytics dashboard',
                    permissions: [],
                },
                {
                    key: 'accessUrl',
                    name: 'Access CEO analytics',
                    permissions: [],
                },
            ],
        },
        {
            key: 'case-submission',
            name: 'common.case_submission',
            isOwner: false,
            actions: [
                {
                    key: 'own',
                    name: 'My case',
                    permissions: [
                        'case::read',
                        'case::create',
                        'case::update',
                        // 'commission::read:salesperson',
                    ],
                },
                {
                    key: 'share',
                    name: 'Share My Case',
                    permissions: [
                        'case::share',
                        'case::read',
                        'case::create',
                        'case::update',
                    ],
                },
                {
                    key: 'view-related-case',
                    name: 'View Co-broke Case',
                    permissions: [
                        'case::read:salesperson',
                    ],
                },
                {
                    key: 'update-doc-related-case',
                    name: 'Update document for Co-broke Case',
                    permissions: ['case::upload:contract'],
                },
                {
                    key: 'view',
                    name: 'Case submission',
                    permissions: [
                        'case::read:submission',
                        'case::approve:submission',
                        'case::process:submission',
                        // 'commission::read:salesperson',
                    ],
                },
            ],
        },
        {
            key: 'personal-case',
            name: 'Personal case',
            isOwner: false,
            actions: [
                {
                    key: 'own',
                    name: 'Case',
                    permissions: [
                        'case::read',
                        'case::create',
                        'case::update',
                        'case::process:submission',
                    ],
                },
            ],
        },
        {
            key: 'project-submission',
            name: 'common.project_transaction',
            isOwner: false,
            actions: [
                {
                    key: 'agent',
                    name: 'My Transaction',
                    permissions: [
                        'project::read:project-transaction',
                        'project::create:project-transaction',
                        'project::update:project-transaction',
                        'project::delete:project-transaction',
                    ],
                },
                {
                    key: 'share',
                    name: 'Share My Transaction',
                    permissions: [
                        'project::share:project-transaction',
                        'project::read:project-transaction',
                        'project::create:project-transaction',
                        'project::update:project-transaction',
                        'project::delete:project-transaction',
                    ],
                },
                {
                    key: 'view-related-transaction',
                    name: 'View Co-broke Transaction',
                    permissions: [
                        'project::read:cobroke',
                    ],
                },
                {
                    key: 'update-doc-related-transaction',
                    name: 'Update document for Co-broke Transaction',
                    permissions: ['project::upload:contract'],
                },
                {
                    key: 'admin',
                    name: 'Project Submission',
                    permissions: [
                        'project::read:project-submission',
                        // 'project::create:project-submission',
                        'project::update:project-submission',
                        // 'project::delete:project-submission',
                        'project::process:project-submission',
                        'project::approve:project-submission',
                    ],
                },
                // {
                //     key: 'assign-other-owner',
                //     name: 'Assign Other Owner',
                //     permissions: [
                //         'project::assign:owner',
                //         'project::read:project-submission',
                //         'project::create:project-submission',
                //         'project::update:project-submission',
                //         'project::delete:project-submission',
                //         'project::process:project-submission',
                //         'project::approve:project-submission',
                //     ],
                // },
            ],
        },
        {
            key: 'invoice',
            name: 'common.invoice',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['invoice::read', 'field::read'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: [
                        'invoice::create',
                        'field::read',
                        'contract::create',
                        'contract::start',
                        'contract::stop',
                        'field::create',
                        'bu::read:user',
                        'commission::read:salesperson',
                    ],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: [
                        'invoice::update',
                        'field::read',
                        'contract::update',
                        'contract::start',
                        'contract::stop',
                        'field::update',
                        'bu::read:user',
                        'commission::read:salesperson',
                    ],
                },
                {
                    key: 'delete',
                    name: 'Delete all',
                    permissions: ['invoice::delete'],
                },
            ],
        },
        {
            key: 'receipt',
            name: 'common.receipt',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['receipt::read'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: ['receipt::create'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: ['receipt::update'],
                },
                {
                    key: 'delete',
                    name: 'Delete all',
                    permissions: ['receipt::delete'],
                },
            ],
        },
        {
            key: 'supplier-invoice',
            name: 'common.bills_to_pay',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['supplier-invoice::read'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: ['supplier-invoice::create'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: ['supplier-invoice::update'],
                },
                {
                    key: 'delete',
                    name: 'Delete all',
                    permissions: ['supplier-invoice::delete'],
                },
            ],
        },
        {
            key: 'credit-note',
            name: 'common.credit_note',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['credit-note::read'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: ['credit-note::create'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: ['credit-note::update'],
                },
                {
                    key: 'delete',
                    name: 'Delete all',
                    permissions: ['credit-note::delete'],
                },
            ],
        },
        {
            key: 'debit-note',
            name: 'common.debit_note',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['debit-note::read'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: ['debit-note::create'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: ['debit-note::update'],
                },
                {
                    key: 'delete',
                    name: 'Delete all',
                    permissions: ['debit-note::delete'],
                },
            ],
        },
        {
            key: 'payout',
            name: 'common.payment_voucher',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['payout::read'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: ['payout::create'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: ['payout::update'],
                },
                {
                    key: 'delete',
                    name: 'Delete all',
                    permissions: ['payout::delete'],
                },
            ],
        }, {
            key: 'batching',
            name: 'Payment Batching',
            actions: [
                {
                    key: 'view',
                    name: 'View Batching',
                    permissions: ['batching::read'],
                },
                {
                    key: 'create',
                    name: 'Create Batching',
                    permissions: ['batching::create'],
                },
                {
                    key: 'update',
                    name: 'Update Batching',
                    permissions: ['batching::update'],
                },
                {
                    key: 'verify',
                    name: 'Verify Batching',
                    permissions: ['batching::verify'],
                },
                {
                    key: 'generate',
                    name: 'Generate Payment Vouchers',
                    permissions: ['batching::generate'],
                },
                {
                    key: 'delete',
                    name: 'Delete Batching',
                    permissions: ['batching::delete'],
                },
            ],
        },
        {
            key: 'supplier-credit-note',
            name: 'common.supplier_credit_note',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['supplier-credit-note::read'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: ['supplier-credit-note::create'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: ['supplier-credit-note::update'],
                },
                {
                    key: 'delete',
                    name: 'Delete all',
                    permissions: ['supplier-credit-note::delete'],
                },
            ],
        },
        {
            key: 'document-workspace-own',
            name: 'My Document Workspace',
            isOwner: false,
            actions: [
                {
                    key: 'view',
                    name: 'View',
                    permissions: ['workspace::read:file', 'workspace::read:folder'],
                },
                {
                    key: 'share',
                    name: 'Share',
                    permissions: ['workspace::share:file', 'workspace::share:folder'],
                },
                {
                    key: 'create',
                    name: 'Create',
                    permissions: ['workspace::create:file', 'workspace::create:folder'],
                },
                {
                    key: 'update',
                    name: 'Update',
                    permissions: ['workspace::update:file', 'workspace::update:folder'],
                },
                {
                    key: 'delete',
                    name: 'Delete',
                    permissions: ['workspace::delete:file', 'workspace::delete:folder'],
                },
                {
                    key: 'download',
                    name: 'Download',
                    permissions: ['workspace::export:file', 'workspace::export:folder'],
                },
            ],
        },
        {
            key: 'document-workspace-company',
            name: 'Company Document Workspace',
            isOwner: false,
            actions: [
                {
                    key: 'view',
                    name: 'View',
                    permissions: ['company-workspace::read:file', 'company-workspace::read:folder'],
                },
                {
                    key: 'share',
                    name: 'Share',
                    permissions: ['company-workspace::share:file', 'company-workspace::share:folder'],
                },
                {
                    key: 'create',
                    name: 'Create',
                    permissions: ['company-workspace::create:file', 'company-workspace::create:folder'],
                },
                {
                    key: 'update',
                    name: 'Update',
                    permissions: ['company-workspace::update:file', 'company-workspace::update:folder'],
                },
                {
                    key: 'delete',
                    name: 'Delete',
                    permissions: ['company-workspace::delete:file', 'company-workspace::delete:folder'],
                },
                {
                    key: 'download',
                    name: 'Download',
                    permissions: ['company-workspace::export:file', 'company-workspace::export:folder'],
                },
            ],
        },
        {
            key: 'document',
            name: 'common.document',
            isOwner: true,
            actions: [
                {
                    key: 'share',
                    name: 'Share',
                    isOwner: false,
                    permissions: ['contract::share'],
                },
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['contract::read', 'field::read'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: [
                        'contract::create',
                        'bu::read:user',
                        'contract::start',
                        'contract::stop',
                        'field::create',
                        'field::read',
                    ],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: [
                        'contract::update',
                        'bu::read:user',
                        'contract::start',
                        'contract::stop',
                        'field::update',
                        'field::read',
                    ],
                },
            ],
        },
        {
            key: 'template',
            name: 'common.template',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: [
                        'content-builder::read:template',
                        'content-builder::create:template',
                        'content-builder::delete:template',
                    ],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: [
                        'content-builder::create:template',
                        'bu::read:user',
                        'content-builder::read:template',
                    ],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: [
                        'content-builder::update:template',
                        'bu::read:user',
                    ],
                },
            ],
        },
        {
            key: 'system-template',
            name: 'common.system_template',
            isOwner: false,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['content-builder::read:template'],
                },
            ],
        },
        {
            key: 'item',
            name: 'common.property',
            isOwner: true,
            actions: [
                {
                    key: 'share',
                    name: 'Share',
                    isOwner: false,
                    permissions: ['item::share'],
                },
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['item::read'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: ['item::create'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: ['item::update'],
                },
            ],
        },
        {
            key: 'client',
            name: 'common.client',
            isOwner: true,
            actions: [
                {
                    key: 'share',
                    name: 'Share',
                    isOwner: false,
                    permissions: ['tenant::share'],
                },
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['tenant::read'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: ['tenant::create'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: ['tenant::update'],
                },
            ],
        },
        {
            key: 'co-broke-agent',
            name: 'Ext Co-broke Salesperson',
            isOwner: true,
            actions: [
                {
                    key: 'share',
                    name: 'Share',
                    isOwner: false,
                    permissions: ['case::share:agent'],
                },
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['case::read:agent'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: ['case::create:agent'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: ['case::update:agent'],
                },
            ],
        },
        {
            key: 'salesperson',
            name: 'Internal Salesperson',
            isOwner: false,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['commission::read:salesperson'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: ['commission::create:salesperson'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: ['commission::update:salesperson'],
                },
                {
                    key: 'delete',
                    name: 'Delete all',
                    permissions: ['commission::delete:salesperson'],
                },
            ],
        },
        {
            key: 'vendor',
            name: 'common.vendor',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View All',
                    permissions: ['vendor::read'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: ['vendor::create'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: ['vendor::update'],
                },
                {
                    key: 'delete',
                    name: 'Delete all',
                    permissions: ['vendor::delete'],
                },
            ],
        },
        {
            key: 'external-agency',
            name: 'common.external_agency',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View All',
                    permissions: ['external-agency::read'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: ['external-agency::create'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: ['external-agency::update'],
                },
            ],
        },
        {
            key: 'commission-distribution',
            name: 'Commission Distribution',
            isOwner: false,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['commission::read:distribution'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: [
                        'commission::confirm:distribution',
                        'commission::reject:distribution',
                    ],
                },
            ],
        },
        {
            key: 'commission-split-matrix',
            name: 'Commission Split Matrix',
            isOwner: false,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['commission::read:split-matrix'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: ['commission::create:split-matrix'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: ['commission::update:split-matrix'],
                },
                {
                    key: 'delete',
                    name: 'Delete all',
                    permissions: ['commission::delete:split-matrix'],
                },
            ],
        },
        {
            key: 'promotion-matrix',
            name: 'Promotion Matrix',
            isOwner: false,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['commission::read:promotion-matrix'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: [
                        'commission::create:promotion-matrix',
                        'commission::read:split-matrix',
                    ],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: [
                        'commission::update:promotion-matrix',
                        'commission::read:split-matrix',
                    ],
                },
                {
                    key: 'delete',
                    name: 'Delete all',
                    permissions: [
                        'commission::delete:promotion-matrix',
                        'commission::read:split-matrix',
                    ],
                },
            ],
        },
        {
            key: 'kyc',
            name: 'common.kyc_aml',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['kyc::read'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: ['kyc::create'],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: ['kyc::update'],
                },
            ],
        },
        {
            key: 'ecdd-hutton',
            name: 'common.dcdd',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: ['ecdd::read'],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: [
                        'ecdd::create',
                        'project::read',
                        'project::read:unit',
                    ],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: [
                        'ecdd::update',
                        'project::read',
                        'project::read:unit',
                    ],
                },
                {
                    key: 'delete',
                    name: 'Delete all',
                    permissions: ['ecdd::delete'],
                },
                {
                    key: 'audit-log',
                    name: 'common.audit_log',
                    permissions: ['ecdd::read:audit'],
                },
            ],
        },
        {
            key: 'dcdd-submission',
            name: 'common.dcdd',
            actions: [
                {
                    key: 'submission',
                    name: 'common.dcdd_submission',
                    permissions: ['ecdd::read:submission'],
                },
            ]
        },
        {
            key: 'exempted-entities',
            name: 'common.exempted_entities',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View all',
                    permissions: [
                        'ecdd::read:exempted-entity'
                    ],
                },
                {
                    key: 'create',
                    name: 'Create all',
                    permissions: [
                        'ecdd::create:exempted-entity',
                    ],
                },
                {
                    key: 'update',
                    name: 'Update all',
                    permissions: [
                        'ecdd::update:exempted-entity',
                    ],
                },
                {
                    key: 'delete',
                    name: 'Delete all',
                    permissions: [
                        'ecdd::delete:exempted-entity'
                    ],
                },
            ],
        },
        {
            key: 'credit-management',
            name: 'common.credit_management',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View Credit Overview',
                    permissions: ['credit-management::read:overview'],
                },
                {
                    key: 'view-usage-log',
                    name: 'View Usage Log',
                    permissions: ['credit-management::read:usage-log'],
                },
                {
                    key: 'view-allocation-history',
                    name: 'View Allocation History',
                    permissions: ['credit-management::read:allocation-history'],
                },
            ],
        },
        {
            key: 'loan-package',
            name: 'loan_package.title',
            actions: [
                {
                    key: 'view',
                    name: 'View Loan Package',
                    permissions: ['mortgage::read:packages'],
                },
                {
                    key: 'create',
                    name: 'Create Loan Package',
                    permissions: ['mortgage::create:packages'],
                },
                {
                    key: 'update',
                    name: 'Update Loan Package',
                    permissions: ['mortgage::update:packages'],
                },
            ],
        },
        {
            key: 'loan-referral',
            name: 'common.loan_referral',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View Loan Referral',
                    permissions: ['mortgage::read:referral'],
                },
                {
                    key: 'create',
                    name: 'Create Loan Referral',
                    permissions: ['mortgage::create:referral'],
                },
                {
                    key: 'update',
                    name: 'Update Loan Referral',
                    permissions: ['mortgage::update:referral'],
                },
                {
                    key: 'process',
                    name: 'Submit Loan Referral',
                    permissions: ['mortgage::process:referral'],
                },
                {
                    key: 'delete',
                    name: 'Delete Loan Referral',
                    permissions: ['mortgage::delete:referral'],
                },
            ],
        },
        {
            key: 'project',
            name: 'common.project_setup',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View Project',
                    permissions: ['project::read'],
                },
                {
                    key: 'create',
                    name: 'Create Project',
                    permissions: ['project::create'],
                },
                {
                    key: 'update',
                    name: 'Update Project',
                    permissions: ['project::update'],
                },
                {
                    key: 'delete',
                    name: 'Delete Project',
                    permissions: ['project::delete'],
                },
            ],
        },
        {
            key: 'project-gallery',
            name: 'Project Gallery',
            isOwner: false,
            actions: [
                {
                    key: 'admin',
                    name: 'Setup for Admin',
                    permissions: [
                        'project::read:gallery',
                        'project::create:gallery',
                        'project::update:gallery',
                    ],
                },
                {
                    key: 'salesperson',
                    name: 'View Only for Salesperson',
                    permissions: ['project::read:gallery'],
                },
            ],
        },
        {
            key: 'project-eoi-booking',
            name: 'Project EOI Booking',
            actions: [
                {
                    key: 'my-eoi-booking',
                    name: 'My EOI Booking',
                    permissions: [
                        'project::read:eoi-booking',
                        'project::create:eoi-booking',
                        'project::update:eoi-booking',
                        'project::delete:eoi-booking',
                        'project::process:eoi-submission',
                        'project::convert:eoi-submission',
                        'project::merge:eoi-submission',
                    ],
                },
                {
                    key: 'ic-review-eoi-booking',
                    name: 'IC (Reviewer)',
                    permissions: [
                        'project::read:eoi-submission',
                        'project::update:eoi-submission',
                        'project::review:eoi-submission',
                    ],
                },
                {
                    key: 'eoi-submission',
                    name: 'EOI Submission',
                    permissions: [
                        'project::read:eoi-submission',
                        'project::update:eoi-submission',
                        'project::approve:eoi-submission',
                        'project::process:eoi-submission',
                        'project::convert:eoi-submission',
                        'project::merge:eoi-submission',
                    ],
                },
            ],
        },
        {
            key: 'project-unit',
            name: 'common.project_unit',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View Project Unit',
                    permissions: ['project::read:unit'],
                },
                {
                    key: 'create',
                    name: 'Create Project Unit',
                    permissions: ['project::create:unit'],
                },
                {
                    key: 'update',
                    name: 'Update Project Unit',
                    permissions: ['project::update:unit'],
                },
                {
                    key: 'delete',
                    name: 'Delete Project Unit',
                    permissions: ['project::delete:unit'],
                },
            ],
        },
        {
            key: 'project-ic',
            name: 'common.project_ic',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View Project IC',
                    permissions: ['project::read:ic'],
                },
                {
                    key: 'create',
                    name: 'Create Project IC',
                    permissions: ['project::create:ic'],
                },
                {
                    key: 'update',
                    name: 'Update Project IC',
                    permissions: ['project::update:ic'],
                },
                {
                    key: 'delete',
                    name: 'Delete Project IC',
                    permissions: ['project::delete:ic'],
                },
            ],
        },
        {
            key: 'project-commission-matrix',
            name: 'common.project_commission_matrix',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View Commission Matrix',
                    permissions: ['project::read:commission-matrix'],
                },
                {
                    key: 'create',
                    name: 'Create Commission Matrix',
                    permissions: ['project::create:commission-matrix'],
                },
                {
                    key: 'update',
                    name: 'Update Commission Matrix',
                    permissions: ['project::update:commission-matrix'],
                },
                {
                    key: 'delete',
                    name: 'Delete Commission Matrix',
                    permissions: ['project::delete:commission-matrix'],
                },
            ],
        },
        {
            key: 'project-appointment-type',
            name: 'common.project_appointment_type',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View Appointment Type',
                    permissions: ['project::read:appointment-type'],
                },
                {
                    key: 'create',
                    name: 'Create Appointment Type',
                    permissions: ['project::create:appointment-type'],
                },
                {
                    key: 'update',
                    name: 'Update Appointment Type',
                    permissions: ['project::update:appointment-type'],
                },
                {
                    key: 'delete',
                    name: 'Delete Appointment Type',
                    permissions: ['project::delete:appointment-type'],
                },
            ],
        },
        {
            key: 'project-overriding-distribution',
            name: 'common.project_overriding_distribution',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View Overriding Distribution',
                    permissions: ['project::read:overriding-distribution'],
                },
                {
                    key: 'create',
                    name: 'Create Overriding Distribution',
                    permissions: ['project::create:overriding-distribution'],
                },
                {
                    key: 'update',
                    name: 'Update Overriding Distribution',
                    permissions: ['project::update:overriding-distribution'],
                },
                {
                    key: 'delete',
                    name: 'Delete Overriding Distribution',
                    permissions: ['project::delete:overriding-distribution'],
                },
            ],
        },
        {
            key: 'reminder',
            name: 'Reminder Setting',
            isOwner: true,
            actions: [
                {
                    key: 'view',
                    name: 'View Reminder Setting',
                    permissions: ['reminder::read'],
                },
                {
                    key: 'create',
                    name: 'Create Reminder Setting',
                    permissions: ['reminder::create'],
                },
                {
                    key: 'update',
                    name: 'Update Reminder Setting',
                    permissions: ['reminder::update'],
                },

                {
                    key: 'delete',
                    name: 'Delete Reminder Setting',
                    permissions: ['reminder::delete'],
                },
            ],
        },
         {
            key: 'recruitment',
            name: 'Recruitment',
            isOwner: false,
            actions: [
                {
                    key: 'my-recruitment',
                    name: 'My Application',
                    permissions: ['recruitment::read:application','recruitment::read:title','recruitment::create:application','recruitment::update:application','recruitment::delete:application'],
                },
                {
                    key: 'recruitment-submission-reviewer',
                    name: 'Application Submission (Reviewer)',
                    permissions: ['recruitment::read:application','recruitment::read:title','recruitment::update:application','recruitment::delete:application','recruitment::process:application'],
                },
                {
                    key: 'recruitment-submission-approver',
                    name: 'Application Submission (Appover)',
                    permissions: ['recruitment::read:application','recruitment::read:title','recruitment::update:application','recruitment::delete:application','recruitment::confirm:application'],
                },
                {
                    key: 'recruitment-management',
                    name: 'Recruitment Management',
                    permissions: ['recruitment::read:application', 'recruitment::confirm:application'],
                }
            ],
        },
        {
            // Reed AI assistant. Every action carries 'assistant::use' (Reed is unavailable without it). What Reed
            // may draft follows case::create / ecdd::create / contract::create: the per-draft rows were removed on
            // 8 Oct 2026, and the two left process personal data with no portal equivalent.
            key: 'assistant',
            name: 'policy.assistant.title',
            isOwner: false,
            actions: [
                {
                    key: 'use',
                    name: 'policy.assistant.use',
                    permissions: ['assistant::use'],
                },
                {
                    key: 'upload-identity',
                    name: 'policy.assistant.upload_identity',
                    permissions: [
                        'assistant::use',
                        'assistant::upload:document',
                    ],
                },
                {
                    key: 'extract-bank-statement',
                    name: 'policy.assistant.extract_bank_statement',
                    permissions: ['assistant::use', 'assistant::extract:bank-statement'],
                },
            ],
        },
        {
            key: 'setting',
            name: 'common.settings',
            isOwner: false,
            actions: [
                {
                    key: 'view',
                    name: 'View Profile',
                    permissions: [],
                },
                {
                    key: 'add-new-group',
                    name: 'Add new group',
                    permissions: [
                        'group::create',
                        'group::read',
                        'group::update',
                        'group::assign:user',
                        'group::revoke:user',
                    ],
                },
                {
                    key: 'activity-log',
                    name: 'View All Activity Log',
                    permissions: [
                        'bu::read:user',
                        'analytic::read:activity',
                    ],
                },
                {
                    key: 'invite-member',
                    name: 'View & Invite Member',
                    permissions: [
                        'bu::read:user',
                        'bu::update',
                        'bu::add:user',
                        'group::read',
                        'group::assign:user',
                        'group::revoke:user',
                    ],
                },
                {
                    key: 'access-control',
                    name: 'Access control',
                    permissions: [
                        'group::read',
                        'group::update',
                        'group::assign:permission',
                        'group::revoke:permission',
                    ],
                },
                {
                    key: 'orgInfo',
                    name: 'Organization & Business Unit',
                    permissions: [
                        'bu::read:user',
                        'bu::read',
                        'group::read',
                        'bu::update',
                        'org::update',
                        'org::read',
                    ],
                },
                {
                    key: 'subscription',
                    name: 'Manage Subscription & Billing',
                    permissions: ['subscription::read', 'subscription::update'],
                },
                {
                    key: 'invoice',
                    name: 'Manage Accounting Settings',
                    permissions: ['invoice::update', 'bu::update', 'bu::read'],
                },
                {
                    key: 'caseSubmission',
                    name: 'Manage Case Submission Requirement',
                    permissions: [
                        'case::update',
                        'case::read',
                        'bu::read:user',
                        'bu::read',
                    ],
                },
                {
                    key: 'project-setting',
                    name: 'policy.project_setting',
                    permissions: [],
                },
                {
                    key: 'zoom',
                    name: 'Manage Zoom Account',
                    permissions: ['org::update', 'org::read'],
                },
                {
                    key: 'kyc',
                    name: 'Manage KYC Account',
                    permissions: ['org::update', 'org::read'],
                },
                {
                    key: 'xero',
                    name: 'Manage Invoice Xero Account',
                    permissions: ['org::update', 'org::read'],
                },
                {
                    key: 'webhook',
                    name: 'Manage webhook',
                    permissions: ['org::update', 'org::read'],
                },
                {
                    key: 'document',
                    name: 'Document setting',
                    permissions: ['org::update', 'org::read'],
                },
                {
                    key: 'mapping',
                    name: 'Template Mapper',
                    permissions: [
                        'content-builder::read:mapping',
                        'content-builder::create:mapping',
                        'content-builder::update:mapping',
                        'content-builder::delete:mapping',
                    ],
                },
                {
                    key: 'retention',
                    name: 'Data Retention Setting',
                    permissions: [
                        'retention::read',
                        'retention::action',
                    ],
                },
            ],
        },
    ];
}

const ConvertPolicies = {};
const AllPolicies = [];

PolicyConstant.MODULES.forEach((mod) => {
    ConvertPolicies[mod.key] = {};
    mod.actions.forEach((action) => {
        ConvertPolicies[mod.key][action.key] = action.permissions;

        if (action.key === 'own') {
            AllPolicies.push(mod.key + '::viewOwner');
            AllPolicies.push(mod.key + '::createOwner');
            AllPolicies.push(mod.key + '::updateOwner');
            AllPolicies.push(mod.key + '::deleteOwner');
        } else {
            AllPolicies.push(mod.key + '::' + action.key);
        }
    });
});

export const Policies = ConvertPolicies;
export const PolicyValues = AllPolicies;
